import { Tooltip as ReactTooltip } from "react-tooltip";
import type { JSX } from "react";
import { InformationCircleOutline } from "./icons";

interface TooltipProps {
  id: string;
  message: string;
}

export const Tooltip = ({ id, message }: TooltipProps): JSX.Element => (
  <span className="inline-flex items-center">
    <ReactTooltip
      className="tooltip max-w-sm whitespace-normal"
      content={message}
      id={id}
      place="right"
    />
    <button
      aria-label={message}
      className="inline-flex border-0 bg-transparent p-0 text-gray-500"
      data-tooltip-content={message}
      data-tooltip-id={id}
      type="button"
    >
      <InformationCircleOutline aria-hidden="true" className="size-5" />
    </button>
  </span>
);

Tooltip.displayName = "Tooltip";

export default Tooltip;
